<div class="row">
  <div class="titleblock">
    <h3 class="title1level">Inserisci nuova cartella</h3>
  </div>
</div>

<div class="row margin-form">
  <form #f="ngForm" [formGroup]="newFolderForm">
    <ng-template [ngIf]="isFolder">
      <div class="row">
        <div textInput class="col-sm-6" [labelInput]="'Aggiungi cartella'"
          [control]="newFolderForm.controls['nomeFile']" formControlName="nomeFile" [(ngModel)]="formRequest.nomeFile"
          [mandatory]="true">
        </div>
      </div>


      <div class="row">
        <p class="col-sm-3 col-xs-6">
          <button type="button" class="btn btn-outline-secondary btn-block" (click)="reset();">Annulla</button>
        </p>
        <p submitButton class="col-sm-3 col-xs-6 col-sm-offset-6" (click)="saveDir();"
          [labelButton]="editNameDir ? 'Modifica' : 'Crea'" [disabled]="!formRequest.nomeFile || checkNameFile()">
        </p>
      </div>
      <div class="row stepper-border-bottom-mb-15">
        <p class="mandatory col-sm-12">
          <em *ngIf="checkNameFile()"
            style="top: -20px;  position: relative; font-size: 13px; color: red; display: block; margin-left: 15px;">
            Non è possibile inserire il carattere <strong>{{separatorePathLogico}}</strong>
          </em>
          <em>* Campi obbligatori</em>
        </p>
      </div>
    </ng-template>
    <!-- FINE NUOVO/MODIFICA NOME CARTELLA -->
  </form>
</div>
